import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  avatar: {
    width: 48,
    height: 48,
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: '100%',
    backgroundColor: GRAY_COLORS[100],
    color: GRAY_COLORS[600],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18
  },
  comment: {
    maxWidth: 620,
    height: 'auto',
    padding: 12,
    borderRadius: '0px 8px 8px 8px',
    border: `1px solid ${GRAY_COLORS[200]}`,
    gap: 8,
    wordBreak: 'break-word'
  }
}))
